/** Single placeholder used for vendor avatar in sidebar, My Profile, etc. */
import vendorDefaultAvatar from "../assets/image/user-image.png";

export default vendorDefaultAvatar;
